import React, { useContext } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useSingleImageUrl } from '@blaze-cms/image-cdn-react';
import { MainContext } from '../../context';
import renderMetaTags from './helpers/render-meta-tags';
import { SOCIAL_META } from './constants';
import { renderTags } from './helpers';

const Header = ({
  name,
  children,
  formattedMetaTitle,
  image,
  contentDocumentHead,
  ...metaData
}) => {
  const { fullUrl } = useContext(MainContext);
  const { url } = image || {};
  const imageUrl = useSingleImageUrl({
    src: url,
    sizeKey: SOCIAL_META
  });

  return (
    <Head>
      <title>{formattedMetaTitle || name}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {contentDocumentHead && renderTags(contentDocumentHead)}
      {renderMetaTags(fullUrl, imageUrl, metaData, name)}
      {children}
    </Head>
  );
};

Header.propTypes = {
  name: PropTypes.string,
  image: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  formattedMetaTitle: PropTypes.string,
  contentDocumentHead: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      props: PropTypes.object,
      content: PropTypes.string
    })
  )
};

Header.defaultProps = {
  name: null,
  children: null,
  formattedMetaTitle: '',
  image: null,
  contentDocumentHead: []
};

export default Header;
